import { HiArrowDownTray } from "react-icons/hi2";
import { withTranslation } from "react-i18next";
import { useState, useEffect, useCallback } from "react";
import {
  showMessage,
  makeAjax,
  url,
  respStatus
} from "../../helpers/global_helper";
import { NavLink } from "react-router-dom";
import { TextDataScript } from "../../pages/utility/TextDataScript";

const FooterApk = ({ t }) => {
  const [apkData, setApkData] = useState([
    {
      qr_link: `data:image/svg+xml;utf8,${encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400">
    <defs>
      <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#e0e0e0" />
        <stop offset="40%" stop-color="#e0e0e0" />
        <stop offset="50%" stop-color="#f5f5f5" />
        <stop offset="60%" stop-color="#e0e0e0" />
        <stop offset="100%" stop-color="#e0e0e0" />
      </linearGradient>

      <mask id="shimmerMask">
        <rect x="-400" y="0" width="400" height="400" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-400 0"
            to="400 0"
            dur="2s"
            repeatCount="indefinite"
          />
        </rect>
      </mask>
    </defs>

    <!-- Base background -->
    <rect width="400" height="400" fill="#f0f0f0" />

    <!-- Image placeholder -->
       <rect x="16" y="10" width="100%" height="320" rx="5" ry="5" fill="#e0e0e0" mask="url(#shimmerMask)" />

  </svg>

    `)}`,
    },
  ]);

  // useCallback to memoize the getApkData function
  const getApkData = useCallback(() => {
    makeAjax(url.ADMIN_API.listAppData, [], url.ADMIN_MS_EXT).then((response) => {
      if (response?.status !== respStatus["SUCCESS"]) {
        showMessage(response.code !== "validation_error" ? response : response.messages);
        return;
      }
      setApkData(response.data);
    });
  }, []);

  // useEffect to fetch data on mount
  useEffect(() => {
    getApkData();
  }, []);

  // Render APK download buttons

  const renderApkItems = () => (
    apkData && Object.values(apkData).map((data, i) => (
      <div key={i} className="footer_download me-3">
        <div className="footer_apk">
          <p>{t(data?.entity_type)}</p>
          {data?.qr_link && (
            <img loading="lazy" alt="Qrcode" src={data.qr_link} />
          )}
          {data?.link && (
            <NavLink to={data.link}>
              <button>
                <HiArrowDownTray />
                <span>
                  {data.entity_type === "android" ? t("apk") : t(data.entity_type)}
                </span>
              </button>
            </NavLink>
          )}
        </div>
      </div>
    ))
  );

  return (
    <>
      <TextDataScript payload={'google_script'} />
      <div className="content test-i">
        {Object.values(apkData).length > 0 && (
          <>
            <h2 className="title text-section_heading">{t("downloads")}</h2>
            <div className="d-flex mt-lg-2 mt-0 align-items-start">
              {renderApkItems()}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default withTranslation()(FooterApk);
